import get from 'lodash/get';

function singleValueMatcher(selections, value) {
  if (!selections.length) {
    return true;
  }

  if (!value) {
    return false;
  }

  return selections.includes(value);
}

export function hasMatchingCountry(line, selectedCountries) {
  return singleValueMatcher(selectedCountries, get(line, 'country.name'));
}

export function hasMatchingGender(line, selectedGenders) {
  return singleValueMatcher(selectedGenders, get(line, 'gender'));
}

export function hasMatchingProductTag(line, selectedProductTags) {
  return singleValueMatcher(selectedProductTags, get(line, 'productTag'));
}

export function hasMatchingCategories(line, selectedCategories) {
  if (!selectedCategories.length) {
    return true;
  }

  return selectedCategories.some(category =>
    line.categories.includes(category),
  );
}
